import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtPostAttachmentTypeList(params) {
  return request(
    `${BASE_URL}/provider/common/attachmenttype/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
